// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__8unbN","hand":"Home_hand__YmsiD","wave":"Home_wave__IYPNs"};